import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';


/**
 * The list of tabs on this page
 */
export enum DevoPipelinePageTabId {
	Pipeline = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum DevoPiplinePageViewId {
	Opportunities = 1,
	Staff = 2,
}


@Injectable({ providedIn: 'root' })
export class DevoPipelinePageService extends PageTabsLayoutPageService<DevoPipelinePageTabId, DevoPiplinePageViewId> {
	
	private static readonly _viewDroplistItems: DroplistItem<never, DevoPiplinePageViewId>[] = [
		{
			uniqueId: DevoPiplinePageViewId.Opportunities,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Opportunities',
				hideText: 'never',
			},
			customSort: '1'
		},
		{
			uniqueId: DevoPiplinePageViewId.Staff,
			iconContext: {
				iconClass: 'fa-grid',
				iconStyle: 'fa-solid',
				text: 'By Staff',
				hideText: 'never',
			},
			customSort: '2'
		},

	];
	constructor() {
		super(DevoPipelinePageService._viewDroplistItems, DevoPipelinePageService.name, DevoPipelinePageTabId.Pipeline, DevoPiplinePageViewId.Opportunities);
	}

	public get viewId() {
		return DevoPiplinePageViewId;
	}

}